export default {
  inputTypeSearch: {
    '-webkit-appearance': 'none',
    '&::-webkit-search-decoration': {
      '-webkit-appearance': 'none',
    },
    '&::-webkit-search-cancel-button': {
      '-webkit-appearance': 'none',
    },
    '&::-webkit-search-results-button': {
      '-webkit-appearance': 'none',
    },
    '&::-webkit-search-results-decoration': {
      '-webkit-appearance': 'none',
    },
  },
};
